module.exports = __webpack_public_path__ + "static/media/VenuesIcon.62aad4b4.svg";